





















































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HeadersDataTable } from "@/typings/vuetify/vDataTable";
import { Contrato } from "@/typings/store/plugins/easyFirestore/contratos";
import { CondicionComercial } from "@/typings/store/plugins/easyFirestore/condicionesComerciales";
import { ItemsTablaContratos } from "@/typings/components/contratos/tabla";
import firebase from "firebase/app";
import "@/helpers/extensions";
import { aFecha } from "@/helpers/fechas";

@Component
export default class TablaUsuarios extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly contratos!: Array<Contrato>;

  options = {
    itemsPerPage: -1,
  };
  headerProps = {
    sortIcon: "mdi-chevron-down",
  };

  get headers(): HeadersDataTable {
    return [
      //{text: "", value: "estado", sortable: false},
      { text: "Contrato", value: "codigo" },
      { text: "Centro Costo", value: "centroCosto" },
      { text: "Local", value: "local" },
      { text: "Rut", value: "rut" },
      { text: "Razón Social", value: "razonSocial" },
      { text: "Nombre Comercial", value: "nombre_comercial" },
      { text: "Desde", value: "fechaInicio" },
      { text: "Hasta", value: "fechaFin" },
      { text: "F. Entrada", value: "" },
      { text: "F. Salida", value: "" },
      { text: "Pdf", value: "pdfContrato" },
      { text: "", value: "opciones", sortable: false },
    ];
  }

  get items(): ItemsTablaContratos {
    return this.contratos.map((contrato) => {
      const codigo = contrato.codigo;
      const centroCosto = contrato.localSnapshot?.centroCosto;
      const local = contrato.localSnapshot?.unidadLocativa;
      const rut = contrato.clienteSnapshot?.rut;
      const razonSocial = contrato.clienteSnapshot?.nombre;
      const nombre_comercial = contrato.clienteSnapshot?.nombre_comercial;

      const fechaInicio = this.formatTimestamp(contrato.fechaInicio);
      const fechaFin = this.formatTimestamp(contrato.fechaFin);

      return {
        razonSocial,
        rut,
        data: contrato,
        codigo,
        centroCosto,
        local,
        nombre_comercial,

        fechaInicio,
        fechaFin,
      };
    });
  }

  /** Acepta Timestamp, Date o texto (contratos cargados por Excel antiguos). */
  formatTimestamp(timestamp: firebase.firestore.Timestamp | string | Date): string {
    const fecha = aFecha(timestamp);
    return fecha ? fecha.toLocaleDateString("es-CL") : "N/A";
  }

  @Emit("abrir-condicion")
  onAbrirCondicion(condicion: CondicionComercial): CondicionComercial {
    return condicion;
  }

  @Emit("abrir-info")
  onAbrirInfo(contrato: Contrato): Contrato {
    return contrato;
  }

  @Emit("abrir-editar")
  onAbrirEditar(contrato: Contrato): Contrato {
    return contrato;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(contrato: Contrato): Contrato {
    return contrato;
  }
}
